module.exports = __webpack_public_path__ + "img/fr_end.9cbea957.png";